<template>
  <v-expansion-panels
    class="expandable-panel"
    :flat="!isExpandable"
  >
    <v-expansion-panel :disabled="!isExpandable">
      <v-expansion-panel-header :color="headingColor">
        {{ title }}
        <slot name="header" />
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
import variables from '../../../styles/_variables.scss';

export default {
  name: 'ExpandablePanel',
  props: {
    title: { type: String, default: '' },
    isWarning: { type: Boolean, default: false },
    color: { type: String, default: '#F9F9F9' },
  },
  computed: {
    isExpandable() {
      // Check if the component has any slots or content to expand
      return !!(this.$slots.default || [])[0];
    },
    headingColor() {
      if (this.isWarning) {
        return variables.warningLight;
      }

      if (this.isExpandable) {
        return variables.grey0;
      }

      return this.color;
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.expandable-panel {
  &.v-expansion-panels {
    border-radius: 8px;
    border-color: $gray3;
    border-width: 0.5px;
    border-style: solid;
    .v-expansion-panel {
      background-color: $gray4 !important;
    }
    .v-expansion-panel-header {
      padding: 0 5px 0 14px;
      min-height: 40px;
      height: 40px;
      border-radius: 8px;
      border: solid 0.5px transparent !important;
      font-size: 0.875rem;
    }
    .v-expansion-panel--disabled {
      color: initial !important; // Ensure disabled state does not change text color
      > .v-expansion-panel-header {
        padding-right: 28px; // add padding, to account for no icon
      }
    }
    .v-expansion-panel--active {
      border-radius: 8px !important; // Maintain border radius on active state
      > .v-expansion-panel-header {
        min-height: 40px; // Prevent height change on active state
        border: solid 0.5px $gray3 !important;
      }
    }
    .v-expansion-panel-content__wrap {
      padding-top: 10px;
      padding-left: 20px;
      font-size: 0.875rem;
    }
  }
}
</style>
